import { useState, useCallback } from "react";
import axios from "axios";

const useS3Upload = ({
  signedUrlEndpoint = "/generate-signed-url",
  onSuccess,
  onError,
} = {}) => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const uploadFile = useCallback(async (file) => {
    if (!file) {
      alert("Please select a file!");
      return;
    }

    setUploading(true);
    setError(null);

    try {
    
      const response = await axios.get(signedUrlEndpoint, {
        params: {
          fileName: file.name,
          fileType: file.type,
        },
      });

      const { url } = response.data;

     
      await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

     
      const fileUrl = url.split("?")[0];

     
      onSuccess?.(fileUrl, file);

      return fileUrl;
    } catch (err) {
      console.error("Upload failed:", err);
      setError(err);
      onError?.(err);
      throw err;
    } finally {
      setUploading(false);
    }
  }, [signedUrlEndpoint, onSuccess, onError]);

  return {
    uploadFile,
    uploading,
    error,
  };
};

export default useS3Upload;
